import { RxJsonSchema } from 'rxdb';
import type { SavepmChecklist } from './savepmChecklist.types';

export const savePmChecklistSchema: RxJsonSchema<SavepmChecklist> = {
  type: 'object',
  version: 0,
  description: 'describes PM Checklist',
  primaryKey: 'pk_uuid',
  properties: {
    inspectionId: { type: ['number', 'null'] },
    assetCategoryInspectionTypeCheckListId: { type: ['number', 'null'] },
    isCompleted: { type: ['boolean', 'null'] },
    comments: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    createdBy: { type: ['string', 'null'] },
    modifiedBy: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    pk_uuid: { type: 'string', maxLength: 36 },
    pkAssetInspectionPMChecklist: { type: ['number', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    inspectorId: { type: ['number', 'null'] },
    fkAssetInspectionTask: { type: ['number', 'null'] },
  },
};
